/** 发多多官网统一使用的淘宝商品购买入口。 */
export const TAOBAO_PURCHASE_URL = 'https://item.taobao.com/item.htm?id=1081041333759&spm=a213gs.v2success.0.0.42334831G4lCZ5&skuId=6133727957379'
